module.exports = __webpack_public_path__ + "img/icon-fom-cash-payment.72a60b0f.png";